<!DOCTYPE html>
<!--
	TODO:
		- Update to userprofile
		- Add vue property to pass "create" or "update"
-->
<template>
	<b-form @submit.prevent="createOrgAdminUser">
		<b-form-group class="name">
			<b-form-group label="First Name" label-for="oa-first-name">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="person-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-first-name" type="text" v-model="firstName" placeholder="First Name"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Middle Name" label-for="oa-middle-name">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="person-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-middle-name" type="text" v-model="middleName" placeholder="Middle Name"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Last Name" label-for="oa-last-name">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="person-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-last-name" type="text" v-model="lastName" placeholder="Last Name"/>
				</b-input-group>
			</b-form-group>
		</b-form-group>
		<b-form-group class="personal_information">
			<b-form-group label="Birthdate" label-for="oa-birthdate">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="calendar-date-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-birthdate" type="date" v-model="birthdate" placeholder="Birthdate"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Full Address" label-for="oa-full-address">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="house-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-textarea id="oa-full-address" v-model="fullAddress" placeholder="Full Address"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="PRC ID" label-for="oa-prc-id">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="file-person-fill" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-prc-id" type="text" v-model="prcId" placeholder="PRC ID"/>
				</b-input-group>
			</b-form-group>
		</b-form-group>
		<b-form-group class="credentials">
			<b-form-group label="Email" label-for="oa-email">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="at" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-email" type="email" v-model="email" placeholder="E-mail" autocomplete="email"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Password" label-for="oa-password">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="asterisk" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-password" type="password" v-model="password" placeholder="Password" autocomplete="new-password"/>
				</b-input-group>
			</b-form-group>
			<b-form-group label="Confirm Password" label-for="oa-confirm-password">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="asterisk" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-confirm-password" type="password" v-model="confirmPassword" placeholder="Confirm Password" autocomplete="new-password"/>
				</b-input-group>
			</b-form-group>
			<b-alert v-model="showPasswordError" variant="danger" dismissible>
				{{passwordError}}
			</b-alert>
			<b-form-group label="Role" label-for="oa-role-group">
				<div class="d-flex align-items-center role-field">
					<b-icon icon="people-fill" class="role-icon mr-2" aria-hidden="true"/>
					<!-- TODO: convert to checkbox for multi-role users -->
					<b-form-radio-group id="oa-role-group" v-model="role" aria-label="Role">
						<b-form-radio value="1">Org Administrator</b-form-radio>
					</b-form-radio-group>
				</div>
			</b-form-group>
			<b-form-group label="Organization Name" label-for="oa-org-name">
				<b-input-group>
					<b-input-group-prepend class="icon">
						<b-icon icon="asterisk" aria-hidden="true"/>
					</b-input-group-prepend>
					<b-form-input id="oa-org-name" type="text" v-model="organizationName" placeholder="Organization Name"/>
				</b-input-group>
			</b-form-group>
		</b-form-group>
		<b-button type="submit">Create User</b-button>
		<b-alert v-model="showCreateError" variant="danger" dismissible>
			{{createError}}
		</b-alert>
		<b-alert v-model="showCreateSuccess" 
				variant="success" 
				:show="dismissMessage" 
				@dismiss-count-down="countdownChanged" 
				@dismissed="dismissCountDown=0" 
				dismissible
				fade>
			{{createSuccess}}
		</b-alert>
	</b-form>
</template>
<style lang="scss" scoped>
	.b-form {
		// was margin: 100px — non-token large px value; replace with spacing tokens
		margin: var(--secudoc-space-8) var(--secudoc-space-6);  // 64px top/bottom, 32px sides
	}
	.icon {
		margin: auto;
		padding: var(--secudoc-space-2);
		font-size: 1rem;
	}
	.role-field {
		padding: var(--secudoc-space-2) var(--secudoc-space-3);
		border: 1px solid var(--secudoc-outline);
		border-radius: var(--secudoc-radius-sm);
		background-color: var(--secudoc-surface-variant);
		min-height: var(--secudoc-form-field-height);
	}
	.role-icon {
		font-size: 1rem;
		color: var(--secudoc-on-surface-variant);
		flex-shrink: 0;
	}
</style>
<script>
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import axios from "axios";
	const config = require("../firebaseconfig.js");

	class User {
		constructor () {
		
		}
	}
	
	export default {
		methods: {
			createOrgAdminUser() {
				//TODO: add validation here
				this.passwordError = "";
				this.showPasswordError = false;
				this.createError = "";
				this.showCreateError = false;
				if (this.password != this.confirmPassword) {
					this.passwordError = "Passwords do not match!";
					this.showPasswordError = true;
				} else {
					//ISSUE : newly created user changed to logged in user
					//Change to FCF, which uses Firebase Admin to create user
					var user = new User();
					user.email = this.email;
					user.password = this.password;
					user.firstName = this.firstName;
					user.middleName = this.middleName;
					user.lastName = this.lastName;
					user.birthdate = this.birthdate;
					user.prcId = this.prcId;
					user.fullAddress = this.fullAddress;
					user.role = parseInt(this.role); //update later to user.roles = [this.role];
					user.organizationName = this.organizationName;
					axios.post(config.functionBaseUrl + "/user", user)
						.then(response => {
							//TODO: update dashboard list
							this.createSuccess = "User has been successfully created!";
							this.showCreateSuccess = true;
							return;
						}).catch(error => {
							console.error("error  " + error);
							this.createError = JSON.stringify(error);
							this.showCreateError = true;
						}
					);
				}
			},
			dismissMessage() {
				this.dismissCountDown = 10;
			},
			countdownChanged(dismissCountdown) {
				this.dismissCountDown = dismissCountdown;
			}
		}, data() {
			return {
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				organizationName: "",
				error: "",
				showPasswordError:false,
				passwordError: "",
				showCreateError: false,
				createError: "",
				showCreateSuccess : false,
				createSuccess: "",
				dismissCountDown: 0
				
			}
		}
	}
</script>
